
import { defineComponent, computed } from 'vue';
import { 
    epicDataComposition, epicSectionsComposition, epicContentComposition,
    epicSidebarComposition, epicNavigationComposition
} from '../../services';
import { overlayComposition } from '@/core/modules/overlay/services';

export default defineComponent({
    setup () {
        const { datum } = epicDataComposition();

        const efficacyResultsFrames = computed(() => {
            return datum.value.slice(6,13)
        })

        const safetyResultsFrames = computed(() => {
            return datum.value.slice(13,15)
        })

        return { 
            ...epicDataComposition(), ...epicSectionsComposition(datum),
            ...overlayComposition(), ...epicContentComposition(), ...epicSidebarComposition(),
            ...epicNavigationComposition(datum), efficacyResultsFrames, safetyResultsFrames
        };
    }
})
